<template>
    <div>
        <ubi-panel>
            <el-container>
                <el-aside width="25%"><h3>{{ $t("posts.edit.auctionsTitle") }}</h3>
                    <p class="text-justify">{{ $t("posts.edit.fillAdPriceDetails") }}</p></el-aside>
                <el-container>
                    <el-main>
                        <el-col :span="24">
                            <el-col :span="24">
                                <el-form-item :label="$labels.pour_investisseur">
                                    <el-radio v-model="post.pour_investisseur" label="oui">{{ $t("general.yes") }}</el-radio>
                                    <el-radio v-model="post.pour_investisseur" label="non">{{ $t("general.no") }}</el-radio>
                                </el-form-item>
                            </el-col>
                        </el-col>
                    </el-main>
                </el-container>
            </el-container>
        </ubi-panel>
        <ubi-panel>
            <el-container>
                <el-aside width="25%"><h3>{{ $t("posts.edit.copropertyTitle") }}</h3>
                    <p class="text-justify">{{ $t("posts.edit.fillCopropertyInformation") }}</p>
                </el-aside>
                <el-container>
                    <el-main>
                        <el-col :span="24">
                            <el-form-item :label="$labels.copropriete">
                                <el-radio v-model="post.copropriete" label="oui">{{ $t("general.yes") }}</el-radio>
                                <el-radio v-model="post.copropriete" label="non">{{ $t("general.no") }}</el-radio>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24" v-if="(isBailleurSocial || isAgence) && post.copropriete === 'oui'">
                          <el-form-item :label="$labels.alur_syndic_en_procedure" >
                            <el-radio v-model="post.alur_syndic_en_procedure" label="oui">{{ $t("general.yes") }}</el-radio>
                            <el-radio v-model="post.alur_syndic_en_procedure" label="non">{{ $t("general.no") }}</el-radio>
                          </el-form-item>
                        </el-col>
                        <el-col :span="24" v-if="post.copropriete == 'oui' ">
                            <el-form-item :label="$labels.alur_nb_lots">
                                <el-input v-model="post.alur_nb_lots">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24" v-if="post.copropriete == 'oui' ">
                            <el-form-item :label="$t('posts.edit.copropertyMonthlyFee')">
                                <el-input v-model="post.charges_copropriete">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24" v-if="post.copropriete == 'oui' ">
                            <el-form-item :label="$labels.alur_copropriete_plan_de_sauvegarde">
                                <el-radio v-model="post.alur_copropriete_plan_de_sauvegarde" label="oui">{{ $t("general.yes") }}</el-radio>
                                <el-radio v-model="post.alur_copropriete_plan_de_sauvegarde" label="non">{{ $t("general.no") }}</el-radio>
                            </el-form-item>
                        </el-col>
                    </el-main>
                </el-container>
            </el-container>
        </ubi-panel>
        <ubi-panel v-if="!isCmiste && !isEspacil">
            <el-container>
                <el-aside width="25%"><h3>{{ $t("posts.edit.mandateTitle") }}</h3>
                    <p class="text-justify">{{ $t("posts.edit.fillMandateInformation") }}</p></el-aside>
                <el-container>
                    <el-main>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item :label="$labels.mandat_type">
                                    <el-radio-group v-model="post.mandat_type">
                                        <el-radio
                                                v-for="mandatTypeChoice in this.$parent.getChoices('mandat_type')"
                                                :key="mandatTypeChoice"
                                                :label="mandatTypeChoice"
                                                :value="mandatTypeChoice">
                                        </el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item :label="$labels.mandat_statut">
                                    <div style="font-size: 12px;"><el-button class="el-icon-error reset-radio"
                                                                                              v-if="post.mandat_statut != '' && post.mandat_statut != undefined && post.mandat_statut != null"
                                                                                              @click="post.mandat_statut = null"
                                                                                              circle></el-button></div>
                                    <el-radio-group v-model="post.mandat_statut">
                                        <el-radio
                                                v-for="madantStatutChoice in this.$parent.getChoices('mandat_statut')"
                                                :label="madantStatutChoice"
                                                :value="madantStatutChoice">
                                        </el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row v-if="post.mandat_statut=='vendu par l\'agence'">
                            <el-col lg="24">
                                <el-form-item :label="$labels.date_compromis">
                                    <el-date-picker
                                            v-model="post.date_compromis"
                                            :placeholder="$labels.date_compromis"
                                            format="dd/MM/yyyy"
                                            value-format="dd/MM/yyyy">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <div class="block">
                                    <el-form-item :label="$labels.date_mandat">
                                        <el-date-picker
                                                v-model="post.date_mandat"
                                                format="dd/MM/yyyy"
                                                value-format="dd/MM/yyyy"
                                                :placeholder="$labels.date_mandat">
                                        </el-date-picker>
                                    </el-form-item>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="block">
                                    <el-form-item :label="$labels.mandat_echeance">
                                        <el-date-picker
                                                v-model="post.mandat_echeance"
                                                format="dd/MM/yyyy"
                                                value-format="dd/MM/yyyy"
                                                :placeholder="$labels.mandat_echeance">
                                        </el-date-picker>
                                    </el-form-item>
                                </div>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item :label="$labels.mandat_numero">
                                    <el-input v-model="post.mandat_numero">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item :label="$labels.vente_intercabinet">
                                    <el-checkbox
                                            v-model="post.vente_intercabinet" true-label="oui" false-label="non"></el-checkbox>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" v-if="post.vente_intercabinet =='oui' || post.intercabinet_repartition_honoraires != null">
                                <el-form-item :label="$t('posts.edit.intercabinetCommission')">
                                    <el-input   v-mask="'#################'" v-model.number="post.intercabinet_repartition_honoraires">
                                        <div slot="append">%</div>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item :label="$labels.proprietaire_nom + ' ' + $t('posts.edit.withoutCivilityAndName')">
                                    <el-input v-model="post.proprietaire_nom">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item :label="$labels.proprietaire_tel_dom">
                                    <el-input v-model="post.proprietaire_tel_dom">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item :label="$labels.proprietaire_tel_bur">
                                    <el-input v-model="post.proprietaire_tel_bur">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item :label="$t('posts.edit.landlordAddress')">
                                    <el-input v-model="post.proprietaire_adresse1">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item :label="$labels.proprietaire_code_postal">
                                    <el-autocomplete
                                            class="inline-input"
                                            v-model="post.proprietaire_code_postal"
                                            :fetch-suggestions="this.$parent.searchPostal"
                                            @select="this.$parent.selectPostalProprietaire"></el-autocomplete>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item :label="$labels.proprietaire_ville">
                                    <el-input v-model="post.proprietaire_ville">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row :gutter="20">
                            <el-col :md="12" :xs="24">
                                <el-form-item :label="$t('posts.edit.realPropertyPostalCode')">
                                    <el-autocomplete
                                            class="inline-input"
                                            v-model="post.code_postal_reel"
                                            :fetch-suggestions="this.$parent.searchPostal"
                                            @select="this.$parent.selectPostalReel"></el-autocomplete>
                                </el-form-item>
                            </el-col>
                            <el-col :md="12" :xs="24">
                                <el-form-item :label="$t('posts.edit.realPropertyCity')">
                                    <el-input v-model="post.ville_reelle"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24">
                                <el-form-item :label="$t('posts.edit.landlordOtherInformation')">
                                    <el-input v-model="post.proprietaire_commentaire" type="textarea" :rows="5">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-main>
                </el-container>
            </el-container>
        </ubi-panel>
    </div>
</template>

<script>
import { getDefinitionDonneeListeeByCode } from '@/services/posts'
import { mapGetters } from 'vuex'

export default {
  name: 'PostEditImmoOfferI',
  props: ['post', 'ddList'],
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['isBailleurSocial', 'isAgence']),
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    userJob () {
      return this.sitimmoUser.metier
    },
    isCmiste () {
      return this.userJob === 'CMI'
    },
    isEspacil () {
      return (this.sitimmoUser.id == '353182')
    }
  },
  methods: {},
  async beforeMount () {
    let codes = ['modalites_recuperation_charges_locatives', 'mandat_statut', 'mandat_type']

    codes = codes.map(function (x) { return x.toUpperCase() })
    const definitionDonneeListeeByCode = await getDefinitionDonneeListeeByCode({ codes: codes })
    if (definitionDonneeListeeByCode.type == 'error') {
      this.$message({ message: this.$t('error.found'), type: 'error' })
      this.loading = false
      return false
    }
    this.$emit('ddList-update', definitionDonneeListeeByCode)
  }
}
</script>

<style>

</style>
